// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const { curry, filter } = require('lodash/fp');

  var SourceDestinationActions = compose(
    withHandlers({
      getWidthRatio: curry(getWidthRatio)
    })
  );

  /**
   * Get ratio width
   * @param {Object} props
   * @returns {String}
   */
  function getWidthRatio(props, d) {
    var item = props.item;
    var ratios = new Array(4);
    var selecteds = [item.copyDataModel, item.copyDashboard, item.copyReport, true];
    var count = filter(function(s) {
      return s === true;
    }, selecteds).length;
    if (count > 0) {
      var ratio = 12 / count;
      if (item.copyDataModel) {
        ratios[0] = ratio;
      }
      if (item.copyDashboard) {
        ratios[1] = ratio;
      }
      if (item.copyReport) {
        ratios[2] = ratio;
      }

      ratios[3] = ratio;
    }

    return ratios;
  }

  module.exports = SourceDestinationActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Izenda.SourceDestinationActions.js